////////////////////////////////////////////
// useDismiss — CLOSE-ON-OUTSIDE-CLICK / ESCAPE FOR POPOVERS
////////////////////////////////////////////
//
// SHARED BY EVERY DROPDOWN (PLATFORM MENU, ACCOUNT MENU). RETURNS A REF TO
// PUT ON THE POPOVER'S WRAPPER; ANY CLICK OUTSIDE IT, OR ESCAPE, CALLS
// onClose. CAPTURE-PHASE CLICK SO A CLICK THAT OPENS ANOTHER MENU STILL
// CLOSES THIS ONE.
import { useEffect, useRef, type RefObject } from "react";

export function useDismiss<T extends HTMLElement>(open: boolean, onClose: () => void): RefObject<T | null> {

  const ref = useRef<T>(null);
  // LATEST CALLBACK WITHOUT RE-BINDING THE LISTENERS
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {

    if (!open) return;

    const onClick = (e: MouseEvent) => {

      if (!ref.current?.contains(e.target as Node)) closeRef.current();
    };
    const onKey = (e: KeyboardEvent) => {

      if (e.key === "Escape") closeRef.current();
    };
    document.addEventListener("click", onClick, true);
    document.addEventListener("keydown", onKey);
    return () => {

      document.removeEventListener("click", onClick, true);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return ref;
}
